import React, { useEffect } from "react";
import { FormProvider, useForm, useWatch } from "react-hook-form";
import { useDispatch } from "react-redux";
import InputForm from "src/components/ComponentesFormularios/InputForm";
import SelectFormVirtualize from "src/components/ComponentesFormularios/SelectFormVirtualize";
import { classResponsiveFormDoubleWidth } from "src/data/ConstantForm";
import Tooltip from "@mui/material/Tooltip";
import { Colors } from "src/assets/colors/Colors";
import { CalendarForm, CalendarFormRange } from "src/components/ComponentesFormularios/CalendarForm";
import { GlobalConstants } from "src/data/GlobalConstants";
import { segmentacionesService } from "src/services/unoauno/apiSegmentaciones";
import { modalCRUDService } from "src/services/modalCRUDService";

const SEGMENTACIONES_TIPOS = [
    { id: 0, text: 'Por Proveedor' },
    { id: 1, text: 'Alguna vez ha comprado' },
    { id: 2, text: 'Frecuencia de compra del mes' },
    { id: 3, text: 'Promedio de frecuencia de compra por mes' },
    { id: 4, text: 'Han comprado por valor de' },
    { id: 5, text: 'Frecuendia por dia de visita' },
    { id: 6, text: 'Cantidad de pedidos' },
    { id: 7, text: 'Pedido anterior' },
    { id: 8, text: 'Segmentacion / Tipologia' },
    { id: 9, text: 'Dia de visita / Segmentacion' },
    { id: 10, text: 'Por version' },
];

const DIAS_SEMANA = [
    {id: "LU", text: "Lunes"},
    {id: "MA", text: "Martes"},
    {id: "MI", text: "Miercoles"},
    {id: "JU", text: "Jueves"},
    {id: "VI", text: "Viernes"},
    {id: "SA", text: "Sabado"},
    {id: "DO", text: "Domingo"},
]

const OPTIONS_SUBTIPO_1 = [
    { id: 1, text: 'El sku' },
    { id: 2, text: 'La categoría' },
];

const OPTIONS_SUBTIPO_2 = [
    { id: 1, text: 'Más de' },
    { id: 2, text: 'Exactamente' },
]

const OPTIONS_SUBTIPO_3 = [
    { id: 1, text: 'Monto por pedido' },
    { id: 2, text: 'Monto mensual' },
    { id: 3, text: 'Adquisición de la app' },
]

const FormCRUDAutomaticas = ({ properties }) => {
    const dispatch = useDispatch();
    const { data: { idProveedor, reload, versiones, proveedores, negocios, productos, categorias, tipologias, segmentacionesProveedores } } = properties;
    console.log("negocios", negocios)
    const methods = useForm({
        defaultValues: {
            nombre: '',
            // negocios,
            // subtipo1: OPTIONS_SUBTIPO_1[0],
            // tipoSegmentacion: SEGMENTACIONES_TIPOS[0]
        }
    });
    const { control, setValue, getValues, formState: { errors } } = methods;

    const changeTipo = useWatch({ control, name: 'tipoSegmentacion' });
    const subtipo1 = useWatch({ control, name: 'subtipo1' });

    useEffect(() => {
        setValue('productos1', null);
        setValue('categorias1', null);
    }, [subtipo1]);

    const saveSegmentacion = async () => {
        if(getValues('nombre') == '') {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes agregar un nombre' } });
            return;
        }

        if(getValues('negocios').length == 0) {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar al menos un negocio' } });
            return;
        }

        if(getValues('tipoSegmentacion') == null) {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar un tipo de segmentación' } });
            return;
        }

        let dataJson = {}
        let subTipo = "";
        dataJson.negocios = getValues('negocios').map(el => el.id)

        switch (changeTipo.id) {
            case 0:
                const proveedorSelected0 = getValues('proveedores0')
                if(proveedorSelected0 == null || proveedorSelected0 == "") {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar al menos un proveedor' } });
                    return;
                }

                dataJson.proveedor = proveedorSelected0.id
                break;
            case 1:
                const subTipo1 = getValues('subtipo1')
                const categoriaSelected1 = getValues('categorias1')
                const productoSelected1 = getValues('productos1')

                if(subTipo1 == null || subTipo1 == "") {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar un subtipo' } });
                    return;
                }

                if(subTipo1.id == 1 && (productoSelected1 == null || productoSelected1 == "")) {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar un producto' } });
                    return;
                }

                if(subTipo1.id == 2 && (categoriaSelected1 == null || categoriaSelected1 == "")) {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar una categoría' } });
                    return;
                }

                subTipo = subTipo1.text

                dataJson.id_Element = subTipo1.id == 1 ? productoSelected1.id : categoriaSelected1.id
                break;
            case 2:
                const subTipo2 = getValues('subtipo2')
                const mes2 = getValues('mes2')
                const veces2 = getValues('veces2')

                if(subTipo2 == null || subTipo2 == "") {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar un subtipo' } });
                    return;
                }

                if(mes2 == null) {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar un mes' } });
                    return;
                }

                if(veces2 == "") {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar una cantidad de veces' } });
                    return;
                }

                subTipo = subTipo2.text
                dataJson.mes = mes2
                dataJson.veces = veces2
                break;
            case 3:
                const subTipo3 = getValues('subtipo2')
                const tempFecha3 = getValues('fecha3')
                const veces3 = getValues('veces3')

                if(subTipo3 == null || subTipo3 == "") {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar un subtipo' } });
                    return;
                }

                if(tempFecha3 == null || tempFecha3?.some(el => el == null)) {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar un rango de fechas válido' } });
                    return;
                }

                if(veces3 == "") {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar una cantidad de veces' } });
                    return;
                }

                let [mesInicio, mesFinal] = tempFecha3

                subTipo = subTipo3.text
                dataJson.mesInicio = mesInicio.toISOString().split('T')[0]
                dataJson.mesFinal = mesFinal.toISOString().split('T')[0]
                dataJson.veces = veces3
                break;
            case 4:
                const subTipo4 = getValues('subtipo3')
                const precioInicio4 = getValues('precioInicio4')
                const precioFinal4 = getValues('precioFinal4')

                if(subTipo4 == null || subTipo4 == "") {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar un subtipo' } });
                    return;
                }

                if(precioInicio4 == "") {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar un precio de inicio' } });
                    return;
                }

                if(precioFinal4 == "") {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar un precio final' } });
                    return;
                }

                subTipo = subTipo4.text
                dataJson.precioInicio = precioInicio4
                dataJson.precioFinal = precioFinal4
                break;
            case 5:
                const diaVisita5 = getValues('diaVisita5')

                if(diaVisita5 == "" || diaVisita5 == null) {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar un día de visita' } });
                    return;
                }

                dataJson.diaVisita = diaVisita5.id
                break;
            case 6:
                const veces6 = getValues('veces6')

                if(veces6 == "") {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar una cantidad de pedidos' } });
                    return;
                }

                dataJson.veces = veces6
                break;
            case 7:
                const veces7 = getValues('veces7')
                const precioInicio7 = getValues('precioInicio7')
                const precioFinal7 = getValues('precioFinal7')

                if(veces7 == "") {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar una cantidad de pedidos' } });
                    return;
                }

                if(precioInicio7 == "") {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar un precio de inicio' } });
                    return;
                }

                if(precioFinal7 == "") {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar un precio final' } });
                    return;
                }

                dataJson.veces = veces7
                dataJson.precioInicio = precioInicio7
                dataJson.precioFinal = precioFinal7
                break;
            case 8:
                const tipologiasSelected8 = getValues('tipologias8')
                const segmentacionesSelected8 = getValues('segmentaciones8')

                if(tipologiasSelected8.length == 0) {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar al menos una tipología' } });
                    return;
                }

                if(segmentacionesSelected8.length == 0) {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar al menos una segmentación' } });
                    return;
                }

                dataJson.tipologias = tipologiasSelected8.map(el => el.id)
                dataJson.segmentacionesProveedor = segmentacionesSelected8.map(el => el.id)
                break;
            case 9:
                const diaVisita9 = getValues('diaVisita9')
                const segmentacionesSelected9 = getValues('segmentaciones9')

                if(diaVisita9 == "" || diaVisita9 == null) {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar un día de visita' } });
                    return;
                }

                if(segmentacionesSelected9.length == 0) {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar al menos una segmentación' } });
                    return;
                }

                dataJson.diaVisita = diaVisita9.id
                dataJson.segmentacionesProveedor = segmentacionesSelected9.map(el => el.id)
                break;
            case 10:
                const versionesSelected = getValues('versiones10')

                if(versionesSelected.length == 0) {
                    dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertWarning , message: 'Debes seleccionar una versión' } });
                    return;
                }

                dataJson.versiones = versionesSelected.map(el => el.id)
                break;
            default:
                break;
        }

        subTipo ||= "No aplica"
        const nombreSegmentacion = getValues('nombre')
        const orden = getValues('orden')

        try {
            await segmentacionesService.saveSegmentacionAutomatica({
                idProveedor,
                nombreSegmentacion,
                tipo: changeTipo.id,
                orden: orden || 0,
                subTipo,
                dataJson: JSON.stringify(dataJson)
            })

            reload();
            modalCRUDService.clear();

            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertSuccess , message: 'Solicitud exitosa' } });
        } catch (error) {
            dispatch({ type: 'setStateAlert', alert: { type: GlobalConstants.alertError , message: "Ya existe una segmentación con el mismo nombre" } });
        }
    }

    const getParametrosSegmentacion = (tipo) => {
        const id = tipo?.id ?? -1;

        switch (id) {
            case 0:
                return (
                    <div className="w-100 d-flex align-items-center row m-0 p-0 mt-3">
                        <SelectFormVirtualize
                            isMulti={false}
                            inputProps={{ control }}
                            disabled={false}
                            showId={false}
                            identificador="proveedores0"
                            label="Proveedores"
                            options={proveedores}
                            required={false}
                            className="px-2 col-4"
                        />
                    </div>
                );
            case 1:
                return (
                    <div className="w-100 d-flex align-items-center row m-0 p-0 mt-3">
                        <SelectFormVirtualize
                            isMulti={false}
                            inputProps={{ control }}
                            disabled={false}
                            showId={false}
                            identificador="subtipo1"
                            label="Subtipo"
                            options={OPTIONS_SUBTIPO_1}
                            required={false}
                            className="px-2 col-4"
                        />

                        <SelectFormVirtualize
                            isMulti={false}
                            inputProps={{ control }}
                            disabled={subtipo1?.id != 1}
                            showId={true}
                            identificador="productos1"
                            label="Productos"
                            options={productos}
                            required={false}
                            className="px-2 col-4"
                        />

                        <SelectFormVirtualize
                            isMulti={false}
                            inputProps={{ control }}
                            disabled={subtipo1?.id != 2}
                            showId={true}
                            identificador="categorias1"
                            label="Categorias"
                            options={categorias}
                            required={false}
                            className="px-2 col-4"
                        />
                    </div>
                );
            case 2:
                return (
                    <div className="w-100 d-flex align-items-center row m-0 p-0 mt-3">
                        <SelectFormVirtualize
                            isMulti={false}
                            inputProps={{ control }}
                            disabled={false}
                            showId={false}
                            identificador="subtipo2"
                            label="Subtipo"
                            options={OPTIONS_SUBTIPO_2}
                            required={false}
                            className="px-2 col-4"
                        />

                        <CalendarForm
                            inputProps={{ control }}
                            disabled={false}
                            identificador="mes2"
                            label="Mes"
                            required={false}
                            className="px-2 col-4"
                        />

                        <InputForm
                            inputProps={{ control }}
                            identificador="veces2"
                            label="Veces"
                            placeholder=""
                            type="number"
                            required={false}
                            textUppercase={false}
                            className="px-2 col-2"
                        />
                    </div>
                );
            case 3:
                return (
                    <div className="w-100 d-flex align-items-center row m-0 p-0 mt-3">
                        <SelectFormVirtualize
                            isMulti={false}
                            inputProps={{ control }}
                            disabled={false}
                            showId={false}
                            identificador="subtipo2"
                            label="Subtipo"
                            options={OPTIONS_SUBTIPO_2}
                            required={false}
                            className="px-2 col-4"
                        />

                        <CalendarFormRange
                            inputProps={{ control }}
                            disabled={false}
                            identificador="fecha3"
                            label="Fecha"
                            required={false}
                            className="w-auto mb-2"
                        />

                        <InputForm
                            inputProps={{ control }}
                            identificador="veces3"
                            label="Veces"
                            placeholder=""
                            type="number"
                            required={false}
                            textUppercase={false}
                            className="px-2 col-2"
                        />
                    </div>
                );
            case 4:
                return (
                    <div className="w-100 d-flex align-items-center row m-0 p-0 mt-3">
                        <SelectFormVirtualize
                            isMulti={false}
                            inputProps={{ control }}
                            disabled={false}
                            showId={false}
                            identificador="subtipo3"
                            label="Subtipo"
                            options={OPTIONS_SUBTIPO_3}
                            required={false}
                            className="px-2 col-4"
                        />

                        <InputForm
                            inputProps={{ control }}
                            identificador="precioInicio4"
                            label="Precio Inicio"
                            placeholder=""
                            type="number"
                            required={false}
                            textUppercase={false}
                            className="px-2 col-2"
                        />

                        <InputForm
                            inputProps={{ control }}
                            identificador="precioFinal4"
                            label="Precio Fin"
                            placeholder=""
                            type="number"
                            required={false}
                            textUppercase={false}
                            className="px-2 col-2"
                        />
                    </div>
                );
            case 5:
                return (
                    <div className="w-100 d-flex align-items-center row m-0 p-0 mt-3">
                        <SelectFormVirtualize
                            isMulti={false}
                            inputProps={{ control }}
                            disabled={false}
                            showId={false}
                            identificador="diaVisita5"
                            label="Dia Visita"
                            options={DIAS_SEMANA}
                            required={false}
                            className="px-2 col-4"
                        />
                    </div>
                );
            case 6:
                return (
                    <div className="w-100 d-flex align-items-center row m-0 p-0 mt-3">
                        <InputForm
                            inputProps={{ control }}
                            identificador="veces6"
                            label="Veces"
                            placeholder=""
                            type="number"
                            required={false}
                            textUppercase={false}
                            className="px-2 col-2"
                        />
                    </div>
                );
            case 7:
                return (
                    <div className="w-100 d-flex align-items-center row m-0 p-0 mt-3">
                        <InputForm
                            inputProps={{ control }}
                            identificador="veces7"
                            label="Pedido anterior"
                            placeholder=""
                            type="number"
                            required={false}
                            textUppercase={false}
                            className="px-2 col-2"
                        />

                        <InputForm
                            inputProps={{ control }}
                            identificador="precioInicio7"
                            label="Precio Inicio"
                            placeholder=""
                            type="number"
                            required={false}
                            textUppercase={false}
                            className="px-2 col-2"
                        />

                        <InputForm
                            inputProps={{ control }}
                            identificador="precioFinal7"
                            label="Precio Fin"
                            placeholder=""
                            type="number"
                            required={false}
                            textUppercase={false}
                            className="px-2 col-2"
                        />
                    </div>
                );
            case 8:
                return (
                    <div className="w-100 d-flex align-items-center row m-0 p-0 mt-3">
                        <SelectFormVirtualize
                            isMulti={true}
                            inputProps={{ control }}
                            disabled={false}
                            showId={true}
                            identificador="tipologias8"
                            label="Tipologias"
                            options={tipologias}
                            required={false}
                            className="px-2 col-4"
                        />

                        <SelectFormVirtualize
                            isMulti={true}
                            inputProps={{ control }}
                            disabled={false}
                            showId={true}
                            identificador="segmentaciones8"
                            label="Segmentaciones"
                            options={segmentacionesProveedores}
                            required={false}
                            className="px-2 col-4"
                        />
                    </div>
                );
            case 9:
                return (
                    <div className="w-100 d-flex align-items-center row m-0 p-0 mt-3">
                        <SelectFormVirtualize
                            isMulti={false}
                            inputProps={{ control }}
                            disabled={false}
                            showId={false}
                            identificador="diaVisita9"
                            label="Dia Visita"
                            options={DIAS_SEMANA}
                            required={false}
                            className="px-2 col-4"
                        />

                        <SelectFormVirtualize
                            isMulti={true}
                            inputProps={{ control }}
                            disabled={false}
                            showId={true}
                            identificador="segmentaciones9"
                            label="Segmentaciones"
                            options={segmentacionesProveedores}
                            required={false}
                            className="px-2 col-4"
                        />
                    </div>
                );
            case 10:
                return (
                    <div className="w-100 d-flex align-items-center row m-0 p-0 mt-3">
                        <SelectFormVirtualize
                            isMulti={true}
                            inputProps={{ control }}
                            disabled={false}
                            showId={false}
                            identificador="versiones10"
                            label="Versiones de la App"
                            options={versiones}
                            required={false}
                            className="px-2 col-4"
                        />
                    </div>
                );
            default:
                return (
                    <div className="w-100 d-flex align-items-center justify-content-center row m-0 p-0 mt-2">
                        <span style={{fontSize: "13pt"}}>Selecciona un tipo de segmentación</span>
                    </div>
                );
        }
    }

    return (
        <FormProvider {...methods}>
            <div className="p-2 d-flex align-items-center flex-column">
                <div className="w-100 d-flex align-items-center row m-0 p-0">
                    <InputForm
                        inputProps={{ control }}
                        identificador="nombre"
                        label="Nombre de la Segmentación"
                        placeholder="Nombre de la Segmentación"
                        required={false}
                        textUppercase={false}
                        className={`${classResponsiveFormDoubleWidth}`}
                        customError={errors.nombre ? "El campo no puede estar vacío" : null} rules={{ minLength: 0 }}
                        style={errors.nombre ? { marginBottom: 0 } : ''}
                    />

                    <SelectFormVirtualize
                        isMulti={true}
                        inputProps={{ control }}
                        disabled={false}
                        showId={true}
                        identificador="negocios"
                        label="Negocios"
                        options={negocios}
                        required={false}
                        className="px-2 col-4"
                        customError={errors.nombre ? "El campo no puede estar vacío" : null} rules={{ minLength: 0 }}
                    />

                    <Tooltip title="Guardar" aria-label="guardar" style={{marginLeft: "10px", position: "absolute", top: "10%", right: "3.5%"}}>
                        <a onClick={saveSegmentacion} className="icon-container-actions d-flex">
                            <div style={{backgroundColor: Colors.COLOR_GREEN_DARK}}/>
                            <i style={{color: Colors.COLOR_GREEN_DARK}} className="fas fa-save fa-2x"/>
                        </a>
                    </Tooltip>
                </div>

                <div className="w-100 d-flex align-items-center row m-0 p-0 mt-2">
                    <SelectFormVirtualize
                        isMulti={false}
                        inputProps={{ control }}
                        disabled={false}
                        showId={true}
                        identificador="tipoSegmentacion"
                        label="Tipo de Segmentación"
                        options={SEGMENTACIONES_TIPOS}
                        required={false}
                        className="px-2 col-3"
                    />

                    <InputForm
                        inputProps={{ control }}
                        identificador="orden"
                        label="Orden"
                        placeholder=""
                        type="number"
                        required={false}
                        textUppercase={false}
                        className="px-2 col-2"
                    />
                </div>

                <div className="mt-4 mb-3 pt-2" style={{width: "98%", borderTop: "0.5px solid #D2D2D2"}}>
                    <strong style={{fontSize: "14pt"}}>Parametros de segmentación:</strong>
                    {getParametrosSegmentacion(changeTipo)}
                </div>
            </div>
        </FormProvider>
    )
}

export default FormCRUDAutomaticas;
